import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import SubscriptionForm from "./SubscriptionForm";

const SubscriptionAdd = () => {
    return (
        <Fragment>
            <SubscriptionForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default SubscriptionAdd;